import { differenceInSeconds } from 'date-fns/differenceInSeconds';
import { isEqual } from 'date-fns/isEqual';
import { z } from 'zod';

import { isoDatetimeToDate } from '../codecs';
import { phaseTypeSchema } from './phase-type';

export type PhaseId = Phase['id'];

export type Phase = z.output<typeof phaseSchema>;
export type PhaseDTO = z.input<typeof phaseSchema>;

export const phaseSchema = z.object({
  createdAt: isoDatetimeToDate,
  end: isoDatetimeToDate,
  id: z.uuid(),
  sessionId: z.uuid(),
  start: isoDatetimeToDate,
  typeIds: z.array(z.uuid()),
  updatedAt: isoDatetimeToDate,
});

export type PhaseWithTypes = z.output<typeof phaseWithTypesSchema>;
export type PhaseWithTypesDTO = z.input<typeof phaseWithTypesSchema>;

export const phaseWithTypesSchema = phaseSchema.extend({
  types: z.array(phaseTypeSchema),
});

export const PhaseUtils = {
  getDuration(phase: Phase): number {
    return differenceInSeconds(phase.end, phase.start);
  },
  timesEqual(phaseA: Phase, phaseB: Phase): boolean {
    return isEqual(phaseA.start, phaseB.start) && isEqual(phaseA.end, phaseB.end);
  },
};
